import type { JSX } from 'react'
import React from 'react'
import { InfiniteLoader } from 'react-virtualized/dist/commonjs/InfiniteLoader'
import { List } from 'react-virtualized/dist/commonjs/List'
import PlayInListItem from '../PlayInListItem'
import { CommunicationType } from '../../services/apiGateway/apiGatewayTypes'

export interface PlayInListProps {
  dataBdd?: string
  list: CommunicationType[]
  total: number
  addedPlayIns?: CommunicationType[]
  fetchChannelCommunications?(startIndex: number, eraseOld: boolean, promiseResolver?: Promise<boolean>): void
  listHeight: number
  scrollToIndex?: number
  emptyRenderer: () => JSX.Element
  showAddButton?: boolean
  showRemoveButton?: boolean
}

class PlayInList extends React.Component<PlayInListProps> {

  componentDidMount () {

    if (this.props.fetchChannelCommunications) this.props.fetchChannelCommunications(0, true)

  }

  isRowLoaded = ({ index }) => {

    return !!this.props.list[index]

  }

  isVideoAdded = (index) => {

    if (this.props.addedPlayIns) {

      const { id: listItemId } = this.props.list[index]

      return this.props.addedPlayIns.some(({ id }) => id === listItemId)

    }

  }

  loadMoreRows = (indexes) => {

    const { startIndex } = indexes

    let promiseResolver
    const promise = new Promise(resolve => {

      promiseResolver = resolve

    })

    if (this.props.fetchChannelCommunications) this.props.fetchChannelCommunications(startIndex, false, promiseResolver)

    return promise

  }

  rowRenderer = ({ key, index, style }) => {

    if (this.isRowLoaded({ index })) {

      return <PlayInListItem
        key={key}
        item={this.props.list[index]}
        style={style}
        showAddButton={this.props.showAddButton}
        isVideoAdded={this.isVideoAdded(index)}
        showRemoveButton={this.props.showRemoveButton}
        dataBdd={this.props.dataBdd ? `${this.props.dataBdd}-item` : undefined}
      />

    }
    else {

      return <div
        key={key}
        style={style}
        data-bdd={this.props.dataBdd ? `${this.props.dataBdd}-item-loading` : undefined}
      >Loading</div>

    }

  }

  render () {

    return (
      this.props.total
        ? <InfiniteLoader
          isRowLoaded={this.isRowLoaded}
          loadMoreRows={this.loadMoreRows}
          rowCount={this.props.total}
          minimumBatchSize={15}
        >
          {({ onRowsRendered, registerChild }) => (
            <List
              height={this.props.listHeight}
              width={540} // Pixel width of the list element, mandated by react virtualized
              rowHeight={123} // Pixel height of the list item, mandated by react virtualized
              onRowsRendered={onRowsRendered}
              ref={registerChild}
              rowCount={this.props.total}
              rowRenderer={this.rowRenderer}
              addedPlayIns={this.props.addedPlayIns}
              scrollToIndex={this.props.scrollToIndex}
            />
          )}
        </InfiniteLoader>
        : this.props.emptyRenderer()
    )

  }

}

export default PlayInList
